import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

const deliveryDatesUrl = '/deliverydates'

@Injectable()
export class DeliveryDateService {
  constructor(private http: HttpClient)
  { }

  public getDeliveryDates(customerId: string): Observable<string[]> {
    const params = new HttpParams().set('customerId', customerId)

    return this.http.get<string[]>(`${environment.baseApiUrl}${deliveryDatesUrl}`, { params })
  }
}
